<!--application form page-->
<div class=" header bg-gradient-nhc-orange pb-6">
  <div class=" container-fluid">
    <div class=" header-body">
      <div class=" row align-items-center py-4">
        <div class=" col-lg-6 col-7">
          <nav
            aria-label="breadcrumb"
            class=" d-none d-md-inline-block ml-md-12"
          >
            <ol class=" breadcrumb breadcrumb-links breadcrumb-dark">
              <li class=" breadcrumb-item">
                <a href="javascript:void(0)" [routerLink]="['/']">
                  <i class=" fas fa-home"></i>
                </a>
              </li>

              <li class=" breadcrumb-item">
                <a href="javascript:void(0)" [routerLink]="['/applications']"> Submitted application </a>
              </li>
              <li class=" breadcrumb-item">
                <a href="javascript:void(0)" > {{projectData.projectName}} </a>
              </li>

            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>

<div class=" container-fluid mt--6">
  <section class="section" id="project-detail">
    <div class="row">
      <div class="col-lg-8 col-md-12 col-sm-12">
        <div id="projectInfo" class=" card-wrapper">
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-md-9 col-lg-9 col-sm-12">
                  <h3 class=" mb-0">Project Information</h3>
                </div>
              </div>


            </div>
            <div class="card-body">

              <div class="form-group">
                <h4>Name</h4>
                <p class="text-muted">{{ projectData.projectName }}</p>
              </div>
              <div class="form-group">
                <h4>Description</h4>
                <p class="text-muted" id="project-description-text">{{ projectData.projectDescription }}</p>
              </div>
              <div class="row">
                <div class="form-group  col-lg-4 col-md-6 col-sm-12">
                  <h4>Budget Frame</h4>
                  <p class="text-muted">{{ projectData.budgetFrame|number:'1.00' }}{{ " " }}{{ projectData.currencyCode }}</p>
                </div>
                <div class="form-group col-lg-4 col-md-6 col-sm-12">
                  <h4>Application Deadline</h4>
                  <p class="text-muted">{{ projectData.dueDate|date:'dd/MM/yyyy' }}</p>
                </div>
                <div class="form-group col-lg-4 col-md-6 col-sm-12">
                  <h4>Type of support</h4>
                  <ul style="list-style: none; padding-left: 0" class="text-muted">
                    <li *ngFor="let support of projectData.typeOfSupports">
                      {{ support.trim() }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12">
        <div id="chatCard" class=" card-wrapper" style="height: 100%">
          <app-chat-channel *ngIf="applicationId" [grantApplicationId]="applicationId"></app-chat-channel>
        </div>
      </div>
    </div>
  </section>
  <app-project-form-detail
    *ngIf="(projectId && status && grantApplicationType === 'Basic')"
    [granApplicationId]="applicationId"
                           [documentDatas]="documentDatas"
                           [projectId]="projectId"
    [graintApplicationStatus] = "status"
    [showMainControl]="false"
    [loadNotDraft]="true"
    [redirectAfterSubmit]="false"
    [showMiniControl]="true"
    [isReadOnly]="this.isReadOnly"
  > </app-project-form-detail>
  <app-emergency-form-detail
    *ngIf="(projectId && status && grantApplicationType === 'Emergency')"
    [granApplicationId]="applicationId"
    [documentDatas]="documentDatas"
    [projectId]="projectId"
    [graintApplicationStatus] = "status"
    [redirectAfterSubmit]="false"
    [isReadOnly]="this.isReadOnly"
  > </app-emergency-form-detail>

  <div class="row">
    <div class="col-lg-8 col-md-12 col-sm-12">
      <div class=" card-wrapper">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-md-9 col-lg-9 col-sm-12">
                <h3 class=" mb-0">Project Support Agreement - Tasks</h3>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="p-2 mb-2">
              <app-tasks *ngIf="this.isFormLoaded" [applicationId]="applicationId" [graintApplicationStaus] = "status"
              [isReadOnly]="this.isReadOnly"></app-tasks>
            </div>
          </div>
        </div>
      </div>
      <div class=" card-wrapper">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-md-9 col-lg-9 col-sm-12">
                <h3 class=" mb-0">
                  Reports Due
                </h3>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="p-2 mb-2">
              <app-report-due 
                *ngIf="this.isFormLoaded"
                [applicationId]="applicationId"
                [graintApplicationStaus] = "status"
                [projectId]="projectId" 
                [isReadOnly]="this.isReadOnly"></app-report-due>
            </div>
          </div>
        </div>
      </div>
      <div class=" card-wrapper">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-md-9 col-lg-9 col-sm-12">
                <h3 class=" mb-0">
                  Submitted Reports
                </h3>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="p-2 mb-2">
              <app-submitted-report 
                *ngIf="this.isFormLoaded" 
                [applicationId]="applicationId" 
                [graintApplicationStaus] = "status"
                [isReadOnly]="this.isReadOnly"></app-submitted-report>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-12 col-sm-12">
      <section id="upload-file" class="section">
        <div class=" card-wrapper">
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-md-9 col-lg-9 col-sm-12">
                  <h3 class=" mb-0">Documents</h3>
                </div>
              </div>
            </div>
            <form [formGroup]="fileForm" class="card-body" (ngSubmit)="onSubmit()">
              <div class="p-2 mb-2">
                <app-upload-form
                  [data]="files"
                  [documentDatas]="documentDatas"
                  [parentForm]="fileForm"
                  [isReadOnly]="this.isReadOnly"
                >
                </app-upload-form>
                <div style="display: flex">

                  <button
                    *ngIf="!this.isReadOnly" 
                    type="submit"
                    class="btn btn-primary "
                    style="display: flex; align-items: center; gap: 0.5rem;"
                  >
                    <i class="fas fa-file-upload"></i>
                    Submit Document
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>


  </div>

</div>



